import styled, { css } from "styled-components";
import { designTokens } from "../../../components/ui/foundation/DesignTokens";

/**
 * Container principal del widget
 */
export const WhatsappTemplatesWidgetContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  margin-top: ${(props) => (props.createTemplate ? "0" : "2rem")};
`;

/**
 * Círculo de color (utilidad)
 */
export const Color = styled.div`
  background-color: ${(props) => props.color};
  width: 15px;
  height: 15px;
  border-radius: 100%;
`;

/**
 * Wrapper para tabla con scroll
 * Usado cuando la tabla necesita altura máxima
 */
export const TableContent = styled.div`
  width: 100%;
  max-height: 500px;
  overflow-y: auto;

  ${(props) =>
    props.newAudience &&
    css`
      margin-top: 114px;
    `}
`;

/**
 * Container del botón de eliminar template
 */
export const DeleteTemplateContainer = styled.div`
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.7;
  }
`;

/**
 * Ícono de eliminar
 */
export const DeleteTemplateIcon = styled.img`
  width: 100%;
  height: 100%;
`;

/**
 * Header de templates (legacy - evaluar si se necesita)
 */
export const WhatsappTemplateHead = styled.header`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

/**
 * Título de template (legacy - mantener por compatibilidad)
 */
export const WhatsappTemplateTitle = styled.p`
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 0.85rem;
  font-weight: 400;
  line-height: 1.5;
  color: #6B7280;
  margin: 0 0 20px 0;
  max-width: 620px;
`;

/**
 * Botón de regresar
 * Estilo moderno siguiendo el Design System V4.0
 * Posicionamiento relativo para evitar superposición en pantallas pequeñas
 */
export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${designTokens.spacing.sm};
  padding: 10px 20px;
  border-radius: ${designTokens.radius.full};
  border: 1px solid ${designTokens.colors.gray[200]};
  background: ${designTokens.colors.gray[100]};
  font-family: ${designTokens.fonts.heading};
  font-size: ${designTokens.fontSizes.sm};
  font-weight: 600;
  color: ${designTokens.colors.gray[800]};
  cursor: pointer;
  transition: all 0.15s ease;
  outline: none;
  white-space: nowrap;
  min-height: 42px;

  &:hover {
    background: white;
    border-color: ${designTokens.colors.gray[300]};
  }

  &:active {
    transform: translateY(1px);
  }

  @media (max-width: 768px) {
    flex: 1;
    justify-content: center;
  }
`;

/**
 * Texto del botón de regresar
 */
export const BackButtonText = styled.span`
  font-family: ${designTokens.fonts.heading};
  font-style: normal;
  font-size: ${designTokens.fontSizes.sm};
  font-weight: 600;
  line-height: 1;
  display: flex;
  align-items: center;
  color: ${designTokens.colors.gray[800]};
`;

/**
 * Container del ícono del botón de regresar
 */
export const BackButtonIconContainer = styled.div`
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

/**
 * Ícono del botón de regresar
 */
export const BackButtonIcon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

// Modern card container matching reference design
export const TemplateCard = styled.div`
  width: 100%;
  background: #FFFFFF;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  padding: 0;
  overflow: hidden;
`;

// Header section with search and button
export const TemplateCardHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid #E5E7EB;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

// Table container
export const WhatsappTemplateTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
`;

export const Thead = styled.thead`
  background: #F9FAFB;
`;

export const Tbody = styled.tbody``;

export const Th = styled.th`
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 0.7rem;
  font-weight: 600;
  line-height: 1.5;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6B7280;
  padding: 10px 14px;
  border-bottom: 1px solid #E5E7EB;

  ${(props) =>
    props.left &&
    css`
      text-align: left;
    `}
`;

export const Tr = styled.tr`
  text-align: center;
  border-bottom: 1px solid #F3F4F6;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: #F9FAFB;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const Td = styled.td`
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 0.85rem;
  font-weight: 400;
  line-height: 1.5;
  color: #374151;
  padding: 14px;

  ${(props) =>
    props.left &&
    css`
      text-align: left;
    `}
`;

// Template Preview Modal Overlay
export const PreviewModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.2s ease;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

// Template Preview Modal Container
export const PreviewModalContainer = styled.div`
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 420px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

// Preview Modal Header
export const PreviewModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #E5E7EB;
  background: #F9FAFB;
`;

// Preview Modal Title
export const PreviewModalTitle = styled.h3`
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 300px;
`;

// Preview Modal Close Button
export const PreviewModalCloseButton = styled.button`
  background: transparent;
  border: none;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  color: #6B7280;
  transition: all 0.15s ease;

  &:hover {
    background: #E5E7EB;
    color: #374151;
  }
`;

// Preview Modal Content
export const PreviewModalContent = styled.div`
  padding: 20px;
  overflow-y: auto;
  max-height: calc(90vh - 120px);
  background: #E5DDD5;
`;

// Simple Text Preview Box (fallback when no components)
export const SimpleTextPreview = styled.div`
  background: white;
  border-radius: 8px;
  padding: 12px 14px;
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #374151;
  white-space: pre-wrap;
  word-wrap: break-word;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
`;

// Template Name Link (clickable)
export const TemplateNameLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 0.85rem;
  font-weight: 500;
  color: #2563EB;
  cursor: pointer;
  text-align: left;
  transition: color 0.15s ease;

  &:hover {
    color: #1D4ED8;
    text-decoration: underline;
  }
`;

// Preview Icon Button
export const PreviewIconButton = styled.button`
  background: transparent;
  border: none;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #6B7280;
  border-radius: 6px;
  transition: all 0.15s ease;

  &:hover {
    background: #F3F4F6;
    color: #374151;
  }
`;
